import { createContext } from 'react';

const SnackbarContext = createContext();
SnackbarContext.displayName = 'Snackbar';

export default SnackbarContext;
